import { Component, input } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { TranslatePipe } from "@ngx-translate/core";
import { KENDO_NUMERICTEXTBOX } from "@progress/kendo-angular-inputs";
import { ChangedFieldDirective } from "../../changed-field.directive";
import { FlightGroup } from "../../form/flight-form-group";

/** The actual N1, N2 and IMP of each engine of the flight. */
@Component({
    selector: "app-engine-data-tab",
    imports: [ChangedFieldDirective, ReactiveFormsModule, TranslatePipe, KENDO_NUMERICTEXTBOX],
    templateUrl: "./engine-data-tab.component.html",
    styleUrl: "../../edit-fields.scss",
})
export class EngineDataTabComponent {
    readonly group = input.required<FlightGroup>();
    /** A single engine aircraft logs no second engine: its fields stay out of the way. */
    readonly engines = input.required<(1 | 2)[]>();

    readonly readings = ["N1", "N2", "Imp"] as const;
}
